import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12h6l-6 8h6","key":"svg-0"}],["path",{"d":"M14 4h6l-6 8h6","key":"svg-1"}]]

const IconZzz = createReactComponent('outline', 'zzz', 'Zzz', __iconNode);

export default IconZzz;